import { useCurrentUser, useToastProvider } from "@qualio/ui-components";
import { useCurrentProduct } from "../useCurrentProduct";
import { useMutation, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { designControlsApi } from "../../api/designControls";
import { ReviewRecord } from "@design-controls/types";

export const useUpdateReview = () => {
  const { t } = useTranslation();
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();
  const { showToast } = useToastProvider();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (review: Partial<ReviewRecord>) =>
      designControlsApi.updateReview(
        companyId,
        productId,
        review.id as string,
        review,
      ),
    onSuccess: async ({ id: reviewId }) => {
      showToast({
        title: t("reviews.notifications.updateSuccess.title"),
        description: t("reviews.notifications.updateSuccess.description"),
        status: "success",
        duration: 5000,
        "data-cy": "toast-review-update-success",
      });

      return Promise.all([
        queryClient.invalidateQueries(["REVIEW_LIST", companyId, productId]),
        queryClient.invalidateQueries([
          "REVIEW",
          companyId,
          productId,
          reviewId,
        ]),
      ]);
    },
    onError: () => {
      showToast({
        title: t("reviews.notifications.updateError.title"),
        description: t("reviews.notifications.updateError.description"),
        status: "error",
        duration: 5000,
        "data-cy": "toast-review-update-error",
      });
    },
  });
};
